import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-test',
  templateUrl: './notice-test.component.html',
  styleUrls: ['./notice-test.component.scss']
})
export class NoticeTestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
